import { supabase } from "./supabaseClient";
async function getSignedImageUrl(path) {
  if (!path) return null;

  const { data, error } = await supabase.storage
    .from(process.env.REACT_APP_SUPABASE_PICTURE)
    .createSignedUrl(path, 60 * 60); // URL válida 1 hora

  if (error) {
    console.error("Error al obtener URL firmada:", error.message);
    return null;
  }
  return data.signedUrl;
}


export default getSignedImageUrl;